module.exports = __webpack_public_path__ + "img/dp-sy-bm3.9b8f12c2.png";